import React from "react";
import style from "./styles.module.css";
import formatUrl from "utils/FormatUrl";
import { useSelector } from "react-redux";
import { selectors as ListingsReducerSelectors } from "../../../../../../redux/slices/v2/ListingReducer";
import {
  linkSearchItems,
  norm,
} from "components/v2/Listings/ListingsRouterUrlHelper";
import { province_to_slug } from "pagesHelpers/ListingPagesHepler/SlugTransformation";

function VoirPlusCard(props) {
  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const handleLinksRedirect = (typeRedirect: string) => {
    const {
      region,
      controlBy,
      meublee,
      no_trigger_search,
      page,
      ...filteredPayload
    } = searchPayload;

    let copySP = {};
    if (filteredPayload.bounds) {
      copySP["bounds"] = [
        filteredPayload.bounds._sw.lat,
        filteredPayload.bounds._sw.lng,
        filteredPayload.bounds._ne.lat,
        filteredPayload.bounds._ne.lng,
      ];
      if (filteredPayload.exclusivite) {
        copySP["exclusivite"] = filteredPayload.exclusivite;
      }
    } else if (window) {
      if (window.cartedesannonces) {
        if (window.cartedesannonces.getBounds) {
          let boundsref = window.cartedesannonces.getBounds();
          copySP["lat"] = window.cartedesannonces.getCenter().lat;
          copySP["lng"] = window.cartedesannonces.getCenter().lng;
          copySP["zoom"] = window.cartedesannonces.getZoom();
          copySP["bounds"] = [
            boundsref._sw.lat,
            boundsref._sw.lng,
            boundsref._ne.lat,
            boundsref._ne.lng,
          ];
        }
      }
    }

    linkSearchItems.map((item) => {
      if (
        (filteredPayload[item] && filteredPayload[item].length) ||
        (typeof filteredPayload[item] == "number" &&
          parseInt(filteredPayload[item].toString()))
      ) {
        copySP[item] = filteredPayload[item];
      }
    });
    if (filteredPayload["province"]) {
      copySP["province"] = province_to_slug[filteredPayload["province"]];
    }

    copySP["zoom"] = searchPayload.zoom ? searchPayload.zoom : 8;

    copySP["commune"] = searchPayload.commune
      ? norm(searchPayload.commune)
      : "";
    copySP["vendu"] = filteredPayload["vendu"];
    const u = new URLSearchParams(copySP).toString();

    let link = `/${props.lang}/${typeRedirect}.htm${u ? `?${u}` : ""}`;

    return link;
  };
  return (
    <div className={style.cardContainer}>
      <div className={style.con}>
        <span className={style.title}>
          {props.t("Voir toutes les annonces a proximité")}
        </span>
        <a
          className={style.btn}
          href={handleLinksRedirect("list")}
          rel="noindex nofollow"
        >
          {props.t("Voir les biens")}
        </a>
      </div>
    </div>
  );
}

export default VoirPlusCard;
